import EfIcon from '@elem/ui/ef-icon';
import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TextComp() {
    const { t } = useLang('theProduct.SectionF');

    return (
        <div className={`${styles.TheComp2} ef-container`}>
            <div className="SectionF-sec">
                <div className="SectionF-sec-l">
                    <div className="SectionF-sec-line1">{t('comp2_title')}</div>
                    <div className="SectionF-sec-line2">{t('comp2_desc')}</div>
                </div>
                <div className="SectionF-sec-r">
                    <EfLink href="https://lin.ee/9LESuPK">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721638768189/aa1.png" />
                    </EfLink>
                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721638779781/aa2.png" />
                </div>
            </div>
        </div>
    );
}
